import React, { useState } from 'react';
import DropDown from 'components/DropDown';
import Modal from 'components/Modal';
import Button from 'components/Button';
import { browserOnBlur } from 'lib/browser-type';
import { customFilter } from 'lib/helpers-select';
import TimesheetApprovalDeclaration from './TimesheetApprovalDeclaration';

const filterConfig = { matchFrom: 'any' };

export const TimesheetRejectModal = (props) => {
  const [selectedRejectReason, selectRejectReason] = useState(props.rejectReasons[0]);

  const rejectTimesheet = () => {
    if (!selectedRejectReason || props.disabled) return;
    props.rejectTimesheet(selectedRejectReason);
    props.onClose();
  };

  return (
    <Modal
      isOpen={props.modalOpen}
      header="Reject Timesheet"
      contentLabel="Reject timesheet"
      onRequestClose={props.onClose}
      contentStyle={{ width: 560, maxWidth: 'calc(100vw - 32px)' }}
      bodyStyle={{ overflowY: 'auto' }}
    >
      <div className="timesheet-decision">
        <label className="timesheet-decision__label" htmlFor="timesheet-reject-reason">Reason for rejection</label>
        <DropDown
          inputId="timesheet-reject-reason"
          name="label"
          defaultValue={selectedRejectReason}
          options={props.rejectReasons}
          onChange={reason => selectRejectReason(reason)}
          isClearable={false}
          filterOption={customFilter(filterConfig)}
          onBlur={browserOnBlur()}
          menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
          menuPosition="fixed"
          customStyles={{ menuPortal: { zIndex: 1000001 } }}
        />
        <TimesheetApprovalDeclaration declaration={props.declaration} />
        <div className="timesheet-decision__actions">
          <Button white className="timesheet-decision__cancel" onClick={props.onClose}>Cancel</Button>
          <Button className="timesheet-decision__reject" onClick={rejectTimesheet} disabled={!selectedRejectReason || props.disabled}>Reject Timesheet</Button>
        </div>
      </div>
    </Modal>
  );
};
